<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col-12 text-center" v-if="!invitation">
        <HMSpinner class="mt-4" v-if="!invitationError" />
      </div>
      <div v-else class="col-12 text-center">
        <div v-if="isLoggedIn">
          <div v-if="teacher" class="d-flex flex-column justify-content-center">
            <h1>
              {{ $t('STUDIO.LABELS.WELCOME') }} {{ user ? userFullName : '' }}
            </h1>
            <p class="mt-4 col-12 col-lg-8 offset-lg-2">
              {{
                $t(
                  'STUDIO.TEXT.YOU_HAVE_BEEN_INVITED_TO_STUDIO_ALREADY_ADMIN',
                  { studio: invitation.studio_name }
                )
              }}
            </p>
            <div
              class="mt-4 d-flex flex-row flex-wrap text-left justify-content-center"
            >
              <HMUserSection
                @click="logout"
                :title="$t('GENERAL.LABEL.LOGGED_IN_AS')"
                :subtitle="user.user_full_name"
                :actionText="
                  $t('GENERAL.LABEL.LOG_OUT_CHOOSE_DIFFERENT_ACCOUNT')
                "
              />
            </div>
          </div>
          <div v-else>
            <img :src="config['studio-invite-img']" class="img-fluid" />
            <h1 class="mt-4">
              {{ $t('STUDIO.LABELS.WELCOME') }} {{ user ? userFullName : '' }}
            </h1>
            <p class="col-12 col-lg-8 offset-lg-2 mt-4">
              {{
                $t('STUDIO.TEXT.CLICK_BELOW_TO_ACCEPT_YOUR_STUDIO_INVITATION', {
                  studio: invitation.studio_name,
                })
              }}
            </p>
            <HMButton
              size="lg"
              color="brand"
              class="mt-4"
              :loading="loading"
              :disabled="loading"
              @click="acceptInvitation"
            >
              {{ $t('STUDIO.BUTTON.ACCEPT_INVITATION') }}
            </HMButton>
          </div>
        </div>
        <div v-else class="col-12">
          <h1>{{ $t('STUDIO.LABELS.WELCOME') }}</h1>
          <p class="mt-4 col-12 col-lg-8 offset-lg-2">
            {{
              $t(
                'STUDIO.TEXT.YOU_HAVE_BEEN_INVITED_TO_STUDIO_LOGGED_OUT_STATE',
                { studio: invitation.studio_name }
              )
            }}
          </p>
          <div
            class="mt-4 d-flex flex-row flex-wrap text-left justify-content-center"
          >
            <HMUserSection
              class="mr-lg-4"
              @click="openLoginModal"
              :title="$t('GENERAL.BUTTON.LOG_IN')"
              :subtitle="$t('GENERAL.LABEL.ALREADY_HAVE_AN_ACCOUNT')"
              :actionText="$t('PRODUCTS.LABELS.LOG_IN')"
            />
            <HMUserSection
              class="mr-lg-4"
              @click="openRegisterModal"
              :title="$t('GENERAL.LABEL.REGISTRATION')"
              :subtitle="$t('GENERAL.LABEL.CREATE_NEW_ACCOUNT_AND_CONTINUE')"
              :actionText="$t('GENERAL.LABEL.CREATE_AN_ACCOUNT')"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="page-bottom-filler"></div>
  </div>
</template>

<script>
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import StudentLogin from '@/web/components/signup/StudentLogin';
import Signup from '@/web/components/signup/Signup';
import { getConfig } from '@/web/utils/configuration';

export default {
  name: 'StudioInvitation',
  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      user: 'user/user',
      teacher: 'user/teacher',
      userFullName: 'user/userFullName',
    }),
    invitationId() {
      return this.$route.params.invitation_unique_id;
    },
    config() {
      return getConfig();
    },
  },
  data() {
    return {
      invitation: null,
      invitationError: null,
      loading: false,
    };
  },
  methods: {
    async loadInvitation() {
      try {
        this.invitation = await this.$store.dispatch(
          'user/getInvitation',
          this.invitationId
        );
      } catch (error) {
        this.invitationError = error;
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load this invitation',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    async acceptInvitation() {
      try {
        this.loading = true;
        await this.$store.dispatch('user/acceptInvitation', this.invitationId);
        const userInfoPromise = await this.$store.dispatch('user/loadUserInfo');
        await userInfoPromise;
        this.$router.replace({ name: 'dashboard' });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to accept this invitation',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
        });
      } finally {
        this.loading = false;
      }
    },
    openLoginModal() {
      this.$modal.show(StudentLogin);
    },
    openRegisterModal() {
      this.$modal.show(Signup, {
        onSignupFn: () => {
          // TODO anything ?
        },
        displayLoginLink: false,
      });
    },
    logout() {
      this.$store.dispatch(`user/logout`);
    },
  },
  mounted() {
    this.loadInvitation();
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
